import { TableCell, TableHeader, TableKit } from '@tiptap/extension-table'
import { Link } from '@tiptap/extension-link'
import { ListItem } from '@tiptap/extension-list'
import type { Attribute, Extensions } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'

import { documentNodeExtensions } from '@/features/documents/nodes/extensions'
import { isAllowedHref } from '@/lib/report-document'

/**
 * Belge editörünün tüm düğüm ve işaretleri. Küme `lib/report-document.ts` şemasıyla aynıdır
 * (kapalı liste): StarterKit'in şemada olmayan parçaları (alıntı, kod, yatay çizgi, üstü çizili,
 * altı çizili, sondaki boş paragraf) kapalıdır; liste öğesi ve tablo hücresi yalnız şemadaki
 * içeriği kabul eder.
 */
export function createDocumentExtensions(): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      blockquote: false,
      code: false,
      codeBlock: false,
      horizontalRule: false,
      strike: false,
      underline: false,
      trailingNode: false,
      listItem: false,
      link: false,
    }),
    // Bağlantı yalnız göreli ya da https (şema ile aynı kural); yazarken otomatik bağlantı yok.
    // `title` özniteliği şemada yok: kaldırıldı.
    Link.extend({
      addAttributes() {
        const { title: _title, ...attributes } = (this.parent?.() ?? {}) as Record<
          string,
          Attribute
        >
        return attributes
      },
    }).configure({
      openOnClick: false,
      autolink: false,
      isAllowedUri: (url) => isAllowedHref(url),
    }),
    ListItem.extend({ content: 'paragraph (paragraph | bulletList | orderedList)*' }),
    TableKit.configure({ table: { resizable: false }, tableCell: false, tableHeader: false }),
    TableCell.extend({ content: 'paragraph+' }),
    TableHeader.extend({ content: 'paragraph+' }),
    ...documentNodeExtensions,
  ]
}
